exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.h5-tabbar[data-v-cbdc44c0] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  background: #fff;\n  border-top: 1px solid #e8e8e8;\n  padding: 6px 0 calc(6px + env(safe-area-inset-bottom));\n  z-index: 100;\n}\n.h5-tabbar-item[data-v-cbdc44c0] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  text-align: center;\n  color: #666;\n  font-size: 12px;\n  line-height: 1.4;\n}\n.h5-tabbar-item i[data-v-cbdc44c0] {\n  font-size: 20px;\n  display: block;\n}\n.h5-tabbar-item.active[data-v-cbdc44c0] {\n  color: #1890ff;\n}\n", ""]);

// exports
